<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Order History'"
      [canGoBack]="true"
      [customBack]="'restocking'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      @if (orders.length === 0) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [body]="'No restock orders yet. Use Order Stock on the Restocking page to create your first preview cart.'" />
          </tidy-row>
        </tidy-alert>
      }
      @for (order of orders; track order.id) {
        <tidy-card>
          <tidy-card-button (action)="goToOrderDetail(order.id)">
            <tidy-row
              [alignLastItemRight]="true"
              class="vertical-align-center extra-bottom-padding">
              <tidy-text
                [header]="order.orderTitle" />
              <span [class]="order.chipClass">{{ order.chipLabel }}</span>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [helper]="order.summaryText" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [helper]="order.dateText" />
            </tidy-row>
            @if (order.extraText) {
              <tidy-row>
                <tidy-text
                  [helper]="order.extraText" />
              </tidy-row>
            }
          </tidy-card-button>
        </tidy-card>
      }
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
